export default "__VITE_ASSET__BnOimnud__"